import { render, staticRenderFns } from "./DontRecognizeDataModal.vue?vue&type=template&id=5d46886a&scoped=true&"
import script from "./DontRecognizeDataModal.vue?vue&type=script&lang=js&"
export * from "./DontRecognizeDataModal.vue?vue&type=script&lang=js&"
import style0 from "./DontRecognizeDataModal.vue?vue&type=style&index=0&id=5d46886a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d46886a",
  null
  
)

export default component.exports